<template>
  <v-menu offset-x>
    <template v-slot:activator="{ on, attrs }">
      <v-btn v-bind="attrs" v-on="on" color="primary" small depressed outlined>
        {{ $t("exchange.fee") }}
      </v-btn>
    </template>
    <v-list style="width: 200px;">
      <div class="font_Medium-12 text-start pa-2 pt-0 underline-fee">
        {{ $t("exchange.fee_amount") }}
      </div>
      <div class="d-flex mx-2 ">
        <div class="limit-fee">
          <p class="mb-2 font_Medium-12 fee-title">
            {{ $t("exchange.limit") }}
          </p>
          <p class="mb-2 font_Medium-12 fee-title">(Maker)</p>
          <p dir="ltr" class="font_Medium-12 fee-value">
            {{ currentCoin.makerFee * 100 }} %
          </p>
        </div>
        <div class="instant-fee">
          <p class="mb-2 font_Medium-12 fee-title">
            {{ $t("exchange.limit") }}
          </p>
          <p class="mb-2 font_Medium-12 fee-title">(Taker)</p>
          <p dir="ltr" class="font_Medium-12 fee-value">
            {{ currentCoin.takerFee * 100 }} %
          </p>
        </div>
      </div>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  props: ["currentCoin"]
};
</script>

<style lang="scss">
.instant-fee {
  background-color: var(--v-gray7-base);
  border-radius: 8px;
  padding: 4px 8px;
  margin: 8px 0 2px 0;
  width: 50%;

  .fee-title {
    text-align: center;
    color: #56606b;
  }

  .fee-value {
    color: var(--v-gray1-base);
    text-align: center;
  }
}

.limit-fee {
  background-color: var(--v-gray7-base);
  border-radius: 8px;
  padding: 4px 8px;
  margin: 8px 0 2px 18px;
  width: 50%;
  .fee-title {
    color: #56606b;
    text-align: center;
  }

  .fee-value {
    color: var(--v-gray1-base);
    text-align: center;
  }
}

.underline-fee {
  border-bottom: 1px solid var(--v-gray5-base);
}
</style>
